/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_AiInputs */

const cs_blog_editor_ai = /** @type {(inputs: Blog_Editor_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI asistent`)
};

const en_blog_editor_ai = /** @type {(inputs: Blog_Editor_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assistant`)
};

/**
* | output |
* | --- |
* | "AI assistant" |
*
* @param {Blog_Editor_AiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_ai = /** @type {((inputs?: Blog_Editor_AiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_AiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_ai(inputs)
	return cs_blog_editor_ai(inputs)
});